import React, { createContext, useContext, useState, useEffect } from 'react';
import { en } from '../locales/en';
import { de } from '../locales/de';

const translations = { en, de };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    // Check for saved language preference
    const savedLang = localStorage.getItem('language');
    if (savedLang && (savedLang === 'en' || savedLang === 'de')) {
      setLanguage(savedLang);
    }
  }, []);

  const switchLanguage = (lang) => {
    if (lang === 'en' || lang === 'de') {
      setLanguage(lang);
      localStorage.setItem('language', lang);
    }
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
